import { buildAssetUrl, runtimeConfig } from './runtime-config';

const constants = {
    baseUrl: runtimeConfig.assetBaseUrl,
    zoomInButtonValue: -0.15,
    zoomOutButtonValue: 0.15,
    anchor: runtimeConfig.anchor,
};

export function getAssetUrl(assetName: string): string {
    return buildAssetUrl(assetName);
}

export default constants;
